import type { Weapon } from "@hd2/data";
import { useEffect, useState } from "react";
import { isExcludedItemName } from "../lib/excluded-items.ts";

let cache: Weapon[] | null = null;
let pending: Promise<Weapon[]> | null = null;

async function fetchWeapons(): Promise<Weapon[]> {
	if (cache) {
		return cache;
	}
	if (!pending) {
		pending = fetch("/api/weapons")
			.then((r) => r.json() as Promise<{ weapons: Weapon[] }>)
			.then((data) => {
				cache = data.weapons.filter((w) => !isExcludedItemName(w.name));
				return cache;
			});
	}
	return pending;
}

export function useWeapons(): {
	weapons: Weapon[];
	loading: boolean;
} {
	const [weapons, setWeapons] = useState<Weapon[]>(() => cache ?? []);
	const [loading, setLoading] = useState(cache === null);

	useEffect(() => {
		if (cache) {
			setWeapons(cache);
			setLoading(false);
			return;
		}
		let alive = true;
		fetchWeapons()
			.then((list) => {
				if (alive) {
					setWeapons(list);
					setLoading(false);
				}
			})
			.catch(() => {
				if (alive) {
					setLoading(false);
				}
			});
		return () => {
			alive = false;
		};
	}, []);

	return { weapons, loading };
}
